import { createFileRoute, redirect } from "@tanstack/react-router";

// Merged into /security-guard-management-software so the two pages stop competing in search. Permanent redirect keeps old links working.
export const Route = createFileRoute("/security-guard-software")({
  beforeLoad: () => {
    throw redirect({ to: "/security-guard-management-software", statusCode: 301 });
  },
});
